//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapState, mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import TasksUtils from "@/components/UserInterfaces/mixins/tasks-utils";
import UnclaimReassignModal from "@/components/tasks/unclaimReassign/unclaimReassignModal.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import { TASKS_STATUS } from "./constants";

export default {
    name: "TaskCardMobile",
    components: {
        AQButton, membersListInfo, UnclaimReassignModal, AQCheckbox, AQMenu
    },
    filters: {
        dateFormatter(dateToFormat) {
            const newData = date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(" ");
            return `${newData[0]} at ${newData[1]}`;
        },
        assignmentTotalNumber(data) {
            const users = data && data.users ? data.users : [];
            const groups = data && data.groups ? data.groups : [];

            return `+${(users.length + groups.length) - 1}`;
        }
    },
    mixins: [TasksUtils],
    props: {
        taskDetails: { type: Object, default: () => {} },
        isTeam: { type: Boolean, default: false },
        isOpen: { type: Boolean, default: false },
        type: { type: String, default: "" },
        tasksChecked: { type: [Boolean, String], default: false },
        fullTaskList: { type: Array, default: () => [] },
        entireSelectedTaskList: { type: Array, default: () => [] },
        bulkTypeSelected: { type: String, default: "" },
        resetSelectedBackground: { type: Boolean, default: false },
        allTasksListIds: { type: Array, default: () => [] },
        bulkCheckbox: { type: [Boolean, String], default: false }
    },
    data() {
        return {
            allTasksStatus: TASKS_STATUS,
            reassignAction: false,
            currentSelectedTaskId: null,
            bulkUnclaimReassignModal: false,
            checkedTaskList: false,
            copySelectedList: [],
            resetBackgroundStyle: this.resetSelectedBackground,
            actionsModel: [],
            actionsOptions: []
        };
    },
    computed: {
        ...mapState("main", ["activePage"]),
        ...mapGetters("userProfile", ["getUserIsManager"]),
        assignmentCondition() {
            return (this.taskDetails.users && this.taskDetails.users.length > 1)
            || (this.taskDetails.groups && this.taskDetails.groups.length > 1)
            || ((this.taskDetails.groups && this.taskDetails.groups.length === 1)
            && (this.taskDetails.users && this.taskDetails.users.length === 1));
        }
    },
    watch: {
        tasksChecked(newValue) {
            if (newValue) {
                this.checkedTaskList = true;
                this.resetBackgroundStyle = false;
                if (this.fullTaskList && this.fullTaskList.length) {
                    this.copySelectedList = Object.assign([], this.fullTaskList);
                }
            } else if (this.bulkCheckbox !== "indeterminate-check") {
                this.checkedTaskList = false;
                this.copySelectedList = [];
            }
            this.$emit("selectedTasksList", { listData: this.copySelectedList });
        },
        entireSelectedTaskList(val) {
            if (!val.length) {
                this.checkedTaskList = false;
            }
        }
    },
    activated() {
        const qCard = document.getElementsByClassName("q-card");
        if (qCard && qCard.length) {
            if (this.isTeam) {
                qCard[0].classList.add("teams-card");
            } else {
                qCard[0].classList.add("simple-card");
            }
        }
    },
    methods: {
        unclaimReassignResponse() {
            this.$emit("refreshTaskList");
        },
        openTaskActions(element) {
            this.actionsOptions = [];
            if (element) {
                const unclaimOption = {
                    label: this.$t("appTasksContainer.unclaimAction"),
                    value: "UNCLAIM"
                };
                const reassignOption = {
                    label: this.$t("appTasksContainer.reassignAction"),
                    value: "REASSIGN"
                };
                if (element.canUnclaim) {
                    this.actionsOptions.push(unclaimOption);
                }
                if (element.canReassign) {
                    this.actionsOptions.push(reassignOption);
                }
            }
        },
        actionTaskOption(taskId, $event) {
            if (taskId && $event && $event.length) {
                this.openDlg(taskId, $event[0].value);
            }
            this.actionsModel = [];
        },
        selectItem(item) {
            this.copySelectedList = this.entireSelectedTaskList;
            let found = false;
            let bulkCheck = true;
            for (let i = 0; i < this.copySelectedList.length; i++) {
                if (this.copySelectedList[i] === item.taskId && !found) {
                    this.copySelectedList.splice(i, 1);
                    found = true;
                }
            }
            if (!found) {
                this.copySelectedList.push(item.taskId);
            }
            if (this.allTasksListIds && this.copySelectedList) {
                if (this.allTasksListIds.length === this.copySelectedList.length) {
                    bulkCheck = true;
                } else if (this.allTasksListIds.length !== this.copySelectedList.length || !this.copySelectedList.length) {
                    bulkCheck = false;
                }
            }
            this.$emit("selectedTasksList", { listData: this.copySelectedList, bulkCheck });
        }
    }
};
